















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BackModalIcon extends Vue {
  @Prop({ default: '30' }) readonly width?: string;
  @Prop({ default: '30' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
